import React from 'react'
import ReactDOM from 'react-dom'

import styles from './lineLoader.module.scss'

type Props = {
  className?: string
  fixed?: boolean
}

const LineLoader = ({ className = '', fixed = false }: Props) => {
  if (fixed)
    return ReactDOM.createPortal(
      <div className={`${styles.container} ${styles.fixed} ${className}`}>
        <div className={styles.bar} />
      </div>,
      document.body,
    )

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.bar} />
    </div>
  )
}

export default LineLoader
